import { AxiosInstance, AxiosResponse } from "axios";
import { XeroContactModel } from "@/models/XeroContactModel";
import { XeroInvoiceModel } from "@/models/XeroInvoiceModel";
import XeroInvoiceSearchModel from "@/models/XeroInvoiceSearchModel";
import Shared from "@/common/shared";

export default class XeroService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async upsertXeroContact(contact: XeroContactModel) {
    const url = `/Xero/user`;
    const res: AxiosResponse<XeroContactModel> = await this.axiosInstance.post<XeroContactModel>(url, contact);
    return res.data;
  }

  public async getXeroContact(): Promise<XeroContactModel> {
    const url = "/Xero/user";
    const res: AxiosResponse<XeroContactModel> = await this.axiosInstance.get<XeroContactModel>(url);
    if (res.status === 404) {
      return Promise.resolve(new XeroContactModel());
    }
    // return Promise.resolve(new XeroContactModel());
    return res.data;
  }

  public async getInvoices(data: XeroInvoiceSearchModel): Promise<XeroInvoiceModel[]> {
    const url = `/Xero/invoice`;
    const res: AxiosResponse<XeroInvoiceModel[]> = await this.axiosInstance.post<XeroInvoiceModel[]>(url, data);
    return res.data || [];
  }

  public async getOnlineInvoiceUrl(invoiceId: string): Promise<string> {
    const url = `/Xero/view-online?invoiceId=${invoiceId}`;
    const res: AxiosResponse<string> = await this.axiosInstance.get<string>(url);

    const customError = new Error();
    if (res.status === 404) {
      customError.name = Shared.notFound;
      customError.message = Shared.messages.INVOICE_NOT_FOUND;
      return Promise.reject(customError);
    }

    if (res.status === 401) {
      customError.name = Shared.unAuthorize;
      customError.message = res.data as string;
      return Promise.reject(customError);
    }

    return res.data;
  }
}
